import { Redirect, Route, Switch } from 'react-router-dom';
import useAuthentication from '~/hooks/use-authentication';
import SetPasswordComponent from '~/pages/SetPassword/main.js';

function DebugRoutes() {
  const { isGod } = useAuthentication();
  if (!isGod) {
    return <Redirect to='/' />;
  }
  return (
    <Switch>
      <Route
        path='/debug/set-password'
        exact
      >
        <SetPasswordComponent />
      </Route>

      <Route path='*'>
        <Redirect to='/' />
      </Route>
    </Switch>
  );
}

export default DebugRoutes;
